"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kyc = void 0;
class Kyc {
    constructor(kyc) {
        this.userId = 0;
        this.fullName = '';
        this.birthdate = new Date();
        this.docTypeId = '';
        this.docIdNumber = '';
        this.streetAddress = '';
        this.city = '';
        this.state = '';
        this.postcode = '';
        this.country = '';
        this.verified = undefined;
        this.docIdPic = '';
        this.selfiePic = '';
        this.proofResPic = '';
        if (!kyc) {
            return;
        }
        this.userId = kyc.userId;
        this.fullName = kyc.fullName;
        this.birthdate = kyc.birthdate;
        this.docTypeId = kyc.docTypeId;
        this.docIdNumber = kyc.docIdNumber;
        this.streetAddress = kyc.streetAddress;
        this.city = kyc.city;
        this.state = kyc.state;
        this.postcode = kyc.postcode;
        this.country = kyc.country;
        this.verified = kyc.verified;
        this.docIdPic = kyc.docIdPic;
        this.selfiePic = kyc.selfiePic;
        this.proofResPic = kyc.proofResPic;
    }
}
exports.Kyc = Kyc;
//# sourceMappingURL=kyc.js.map